import { render, staticRenderFns } from "./FormAssignTemporalOwner.vue?vue&type=template&id=4a7feb9e&lang=pug"
import script from "./FormAssignTemporalOwner.vue?vue&type=script&lang=js"
export * from "./FormAssignTemporalOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a7feb9e')) {
      api.createRecord('4a7feb9e', component.options)
    } else {
      api.reload('4a7feb9e', component.options)
    }
    module.hot.accept("./FormAssignTemporalOwner.vue?vue&type=template&id=4a7feb9e&lang=pug", function () {
      api.rerender('4a7feb9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormAssignTemporalOwner.vue"
export default component.exports